export default __webpack_public_path__ + "static/media/icon_link.60927f2a.svg";